import { Suspense } from "react";
import {
  Navigate,
  Routes as ReactRouterDomRoutes,
  Route,
} from "react-router-dom";

import { get } from "../services/cookies";

import Layout from "../layout";
import routesConfig from "./routes.config";
import { useSelector } from "react-redux";
import Loader from "@/components/common/loaders/Loader";

const Common = (route) => (
  <Suspense fallback={<Loader />}>
    <route.component />
  </Suspense>
);

const Public = (route) => {
  const { component: Component } = route;
  return (
    <Suspense fallback={<Loader />}>
      <Component />
    </Suspense>
  );
};

const Private = (route) => {
  const { component: Component } = route;
  const token = get("token");
  if (!token) {
    return null;
  } else {
    if (token) {
      return (
        <Suspense fallback={<Loader />}>
          <Component />
        </Suspense>
      );
    } else {
      return <Navigate to={"/"} />;
    }
  }
};

const createNestedRoutes = (routes, RouteType) => {
  return routes.map((route, i) => {
    if (!route.component) {
      throw new Error("Component must be required....");
    }
    if (route.children) {
      return (
        <Route path={route.path} key={i} element={<RouteType {...route} />}>
          {createNestedRoutes(route.children, RouteType)}
        </Route>
      );
    } else {
      return (
        <Route
          key={i}
          index={route.index}
          path={route.path}
          element={<RouteType {...route} />}
        />
      );
    }
  });
};

const Routes = () => {
  const {isAuth} = useSelector((state)=>state?.auth)
  const { common, private: privateRoutes, public: publicRoutes } = routesConfig;
  return (
    <ReactRouterDomRoutes>
      {isAuth ? (
        <Route path="/" element={<Layout />}>
          {createNestedRoutes(privateRoutes, Private)}
        </Route>
      ) : (
        createNestedRoutes(publicRoutes, Public)
      )}
      {createNestedRoutes(common, Common)}
    </ReactRouterDomRoutes>
  );
};

export default Routes;
